var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 192,
    viewBox: "0 0 320 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9 24.7L4.7 26.8L140.7 183.3C145.3 188.6 152.2 191.9 159.9 191.9C167.6 191.9 174.5 188.5 179.1 183.3L315 27.1L317.3 24.5C319 22 320 19 320 15.8C320 7.1 312.6 0 303.4 0H16.6C7.4 0 0 7.1 0 15.8C0 19.1 1.1 22.2 2.9 24.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.e6c1d42292ac59d52ccd1a55303aa753.svg";
export { ForwardRef as ReactComponent };